import { useQuery } from "@tanstack/react-query";
import { getHome } from "../services/homeService";

export const useHome = (userId?: string, token?: string | null) => {
  return useQuery({
    queryKey: ["home", userId],
    queryFn: () => getHome(userId as string, token as string),
    enabled: !!userId && !!token,
    staleTime: 0,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
  });
};